import { SearchTypeEnum } from "@/enum/SearchTypeEnum.ts";
import { ChargingTypeEnum } from "@/enum/ChargingTypeEnum.ts";

export class BaseFilterDto {
    searchType?: SearchTypeEnum;
    chargingType?: ChargingTypeEnum;
    isCompleted?: boolean;
    startDate?: string;
    endDate?: string;
    searchText?: string;
}